<div
  class="member-header bg-white border border-neutral-300 border-t-0 rounded-b-sm flex flex-wrap p-form-widget p-form-view-data px-2 pt-2"
  [class.border-red-400]="showExtendData && memberInfo?.isEscalatedCase"
  >
  <div class="md:w-1/4 lg:w-1/3">
    <div class="field">
      <label>Name:</label>
      <div class="p-field-value">
        <div class="readonly-field-borderless">
          {{ memberData?.member.firstName }}
          {{ memberData?.member.lastName }}
        </div>
      </div>
    </div>
    <div class="field">
      <label>Member ID:</label>
      <div class="p-field-value">
        <div class="readonly-field-borderless break-all">
          {{ memberData?.member.displayMemberId !== null ?
          memberData?.member.displayMemberId : memberData?.member.subscriberNumber }}
        </div>
      </div>
    </div>
    @if (shouldShowGroupId()) {
      <div class="field">
        <label>Group ID:</label>
        <div class="p-field-value">
          <div class="readonly-field-borderless">
            {{ groupId }}
          </div>
        </div>
      </div>
    }

    <div class="field">
      <label>Date of Birth:</label>
      <div class="p-field-value">
        <div class="readonly-field-borderless">
          <span tooltipPosition="right" [pTooltip]="age">
            {{ memberData?.member.dateOfBirth | date: 'MM/dd/yyyy' }}
          </span>
        </div>
      </div>
    </div>
    @if (showExtendData) {
      <div class="field">
        <label>Gender:</label>
        <div class="p-field-value">
          <div class="readonly-field-borderless">
            {{ gender }}
          </div>
        </div>
      </div>
    }
    @if (showExtendData) {
      <div class="field">
        <label>Language:</label>
        <div class="p-field-value">
          <div class="readonly-field-borderless">
            {{ memberInfo?.memberLanguage }}
          </div>
        </div>
      </div>
    }
    @if (showExtendData) {
      <div class="field">
        <label>{{ this.facilityType }} Benefit Days Remaining:</label>
        <div class="p-field-value">
          <div class="readonly-field-borderless">
            <span>{{ snfBenefitDays | emptyPlaceholder  }}</span>
            @if (snfExhaustedDate) {
              <span> - (ended on {{ snfExhaustedDate  | date:'MM/dd/yyyy' }})</span>
            }
          </div>
        </div>
      </div>
    }
  </div>
  <div class="md:w-1/4 lg:w-1/3">
    <div class="field">
      <label>Health Plan:</label>
      <div class="p-field-value">
        <div class="readonly-field-borderless">
          <span class="health-plan {{ memberData?.benefit?.healthPlan | menuColorClass }}">
            {{ memberData?.benefit?.healthPlan }}
          </span>
        </div>
      </div>
    </div>
    @if (showExtendData) {
      <div class="field">
        <label>Health/Benefit Plan:</label>
        <div class="p-field-value">
          <div class="readonly-field-borderless">
            <div class="flex flex-wrap mark-spacing">
              @if (lineOfBusiness?.text !== 'Commercial' ) {
                <span class="break-all">
                  {{ memberData?.benefit?.benefitPlan }}
                </span>
              }
              <div class="flex flex-wrap mark-spacing">
                @if (lineOfBusiness?.text === 'Commercial') {
                  <button
                    pButton
                    class="p-button-link p-0 text-left eoc"
                    [label]="memberData?.benefit?.benefitPlan"
                    [pTooltip]="getTooltipMessage"
                    tooltipPosition="bottom"
                    (click)="downloadDocument()"
                  ></button>
                }
                @if (memberData?.benefit?.benefitPlanClassificationType) {
                  <duals-indicator 
                    [planType]="memberData?.benefit?.benefitPlanClassificationType"
                    [mcoName]="memberData?.benefit?.mcoName"
                    [mcoState]="memberData?.benefit?.mcoState"
                  ></duals-indicator>
                } @else {
                  <span class="mark {{ lineOfBusiness?.class }}">{{ lineOfBusiness?.text }}</span>
                }
              </div>
            </div>
            @if (showMaStateMandateMessage() && showExtendData) {
              <div class="ohio-condition mt-1">
                <i class="pi pi-exclamation-triangle mr-1"></i>
                <span>Follow the WA State mandate-specific process</span>
              </div>
            }
            @if (showInMandateApplies() && showExtendData && showWaGroupIdentifier) {
              <div class="mark cova-identifier">
                <i class="pi pi-exclamation-triangle mr-1"></i>
                <span>IN State Mandate Applies</span>
              </div>
            }
          </div>
        </div>
      </div>
    }
    @if ((memberData?.benefit.programState === 'IN' || (memberData?.benefit.programState === 'TX' && memberData?.benefit.healthPlan === 'Wellpoint')) && utilizationReviewNumber) {
      <div class="field">
        <label>UR Number:</label>
        <div class="p-field-value">
          <div class="readonly-field-borderless">{{ utilizationReviewNumber }}</div>
        </div>
      </div>
    }

    @if (showExtendData && showCovaIdentifier || isOHIO) {
      <div
         [class] ="{
          'mark cova-identifier': showExtendData && showCovaIdentifier,
          'ohio-condition' : isOHIO
         }" >
        <i class="pi pi-exclamation-triangle mr-1"></i>
        <span>Follow the State of OH/COVA-specific process</span>
      </div>
    }
    @if (showExtendData) {
      <div class="field">
        <label>Eligibility:</label>
        <div class="p-field-value">
          @if (!(memberData?.member?.delegationStatus === 'Non-Delegated')) {
            <span>
              <div class="readonly-field-borderless flex flex-wrap mark-spacing">
                <span>
                  {{ memberData?.benefit.beginDate | date: 'MM/dd/yyyy' }}
                  -
                  {{ memberData?.benefit.endDate | date: 'MM/dd/yyyy' }}
                </span>
                @if (!memberData?.benefit.isEligible) {
                  <span class="mark not-eligible">
                    Inactive
                  </span>
                } @else {
                  <span class="mark active">Active</span>
                }
                @if (lineOfBusiness?.text === 'Commercial' && showFundingIndicator()) {
                  <span>
                    <i class="pi pi-info-circle ml-2" tooltipPosition="bottom" [pTooltip]="getFundingTypeTooltipText()"></i>
                  </span>
                }
              </div>
            </span>
          } @else {
            <span>Non-Covered Prospect Member</span>
          }
        </div>
      </div>
    }
    @if (showExtendData) {
      <div class="field">
        <label>Health Plan Specialty Program:</label>
        <div class="p-field-value">
          <div class="readonly-field-borderless">{{ specialtyProgram }}</div>
        </div>
      </div>
    }
    <div class="field" *accessView="['PrimaryCarePhysicianHistory.Read']">
      @if (lineOfBusiness?.text === 'Commercial' && primaryCarePhysician?.primaryCarePhysicianHistoryId) {
        <label>NEHP:</label>
        <div class="p-field-value">
          <div class="readonly-field-borderless flex flex-wrap mark-spacing">
            <span>
              {{ primaryCarePhysician.physicianEffectiveDate | date: 'MM/dd/yyyy' }}
              -
              {{ primaryCarePhysician.physicianEndDate | date: 'MM/dd/yyyy' }}
            </span>
            <span class="mark" [class]="primaryCarePhysician.status === 'Active' ? 'active' : 'inactive'">
              {{ primaryCarePhysician.status }}
            </span>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="md:w-1/4 lg:w-1/3">
    <div class="field">
      <label>Member State:</label>
      <div class="p-field-value">
        <div class="readonly-field-borderless">
          {{ memberData?.address?.state }}
          @if (!isExternal) {
            <mnc-member-disaster-declaration-badge
              lazyComponent
              [subscriberNumber]="memberData?.member.subscriberNumber"
              [tenantId]="tenantId"
              [lineOfBusiness]="lineOfBusiness?.text"
            ></mnc-member-disaster-declaration-badge>
          }
        </div>
      </div>
    </div>
    @if (showExtendData) {
      <div class="field">
        <label>C3:</label>
        <div class="p-field-value">
          <div class="readonly-field-borderless">{{ c3 }}</div>
        </div>
      </div>
    }
    @if (showExtendData) {
      <div
        class="field"
        [class.escalated-case-member]="memberInfo?.isEscalatedCase"
        >
        <label>Assigned Liaison:</label>
        <div class="p-field-value">
          <div class="readonly-field-borderless">
            {{ assignedLiaison }}
          </div>
        </div>
      </div>
    }
    @if (memberData?.member.assignedLiaison && showExtendData) {
      <div
        class="field"
        [class.escalated-case-member]="memberInfo?.isEscalatedCase"
        >
        <label>Assigned Liaison Name:</label>
        <div class="p-field-value">
          <div class="readonly-field-borderless">
            {{ memberData.member.assignedLiaisonName }}
          </div>
        </div>
      </div>
    }
    @if (showExtendData) {
      <div class="field">
        <label>POA/AOR Name:</label>
        <div class="p-field-value">
          <div class="readonly-field-borderless">
            {{ memberData?.member.aorName }}
          </div>
        </div>
      </div>
    }
    @if (showExtendData) {
      <div class="field">
        <label>POA/AOR Date Signed:</label>
        <div class="p-field-value">
          <div class="readonly-field-borderless">
            {{ memberData?.member.aorDateSigned | date: 'MM/dd/yyyy' }}
          </div>
        </div>
      </div>
    }
  </div>

  @if (showLoader) {
    <div class="loading-overlay flex justify-center items-center">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
</div>
